module.exports = __webpack_public_path__ + "static/img/ic_bottom_viewmore_off@2x.34ffc5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_bottom_viewmore_off@2x.png
// module id = kxaM
// module chunks = 1